<app-card [titleKey]="translationKey + 'cardTitle'">
  <div>
    <label class="sub-section-header">{{
      translationKey + "mainRights" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{
        projectDetails().keyRightsForTransferableSecuritiesOrCrowdfundingAssets
      }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "restrictions" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{
        projectDetails()
          .keyRightsForTransferableSecuritiesOrCrowdfundingAssetsDenial
      }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "descriptionOfRestriction" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{
        projectDetails()
          .keyRightsForTransferableSecuritiesOrCrowdfundingAssetsRestrictions
      }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "exitOptions" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{ projectDetails().exitOptionsForInvestors }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "equityInstruments" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{
        projectDetails().capitalAndVotingRightsDistributionBeforeAndAfterOffer
      }}
    </p>
  </div>
</app-card>
